var React = require('react');

function ChevronRight (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M36 72L60 48L36 24","stroke":"#130A09","strokeWidth":"8","strokeLinecap":"round","strokeLinejoin":"round"}));
}

ChevronRight.defaultProps = {"width":"96","height":"96","viewBox":"0 0 96 96","fill":"none"};

module.exports = ChevronRight;

ChevronRight.default = ChevronRight;
